import { createContext } from "react";
import DefaultClient from "src/api/client";

export const ServiceStackClientContext = createContext(DefaultClient("/", undefined));

export default ServiceStackClientContext;
